import { Box, Tab, Tabs } from '@mui/material'
import { getTitle } from 'components/tabs/TabsTitle'
import { SyntheticEvent, useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { routes } from 'routes/routes'
import { AccessCodeDropdownItem, Pathway, TableResponse, UserEditTab, UserModel } from 'types'
import { getRoute } from 'utils'
import { UserDetailsBreadcrumbs } from '../UserDetailsBreadcrumbs/UserDetailsBreadcrumbs'
import { UserDetailsForm } from '../UserDetailsForm/UserDetailsForm'
import { UserHistory } from '../UserHistory/UserHistory'
import { UserNotifications } from '../UserNotifications/UserNotifications'

export function UserTraineeDetails({
  user,
  pathways,
  accessCodes,
  userId,
  needUpdateHistory,
  onAfterUpdate,
  onResetNeedUpdateHistory,
}: {
  user: UserModel
  pathways: TableResponse<Pathway>
  accessCodes: AccessCodeDropdownItem[]
  userId: number
  needUpdateHistory: boolean
  onAfterUpdate: () => void
  onResetNeedUpdateHistory: () => void
}) {
  const navigate = useNavigate()
  const { tab } = useParams()

  const selectedTab = useMemo(() => {
    if (!tab) return UserEditTab.Details

    return tab as UserEditTab
  }, [tab])

  const handleChangeSelectedTab = useCallback(
    (_: SyntheticEvent, newValue: UserEditTab) => {
      const route = getRoute(routes.userDetails, { userId, tab: newValue })
      navigate(route)
    },
    [navigate, userId],
  )

  return (
    <>
      <UserDetailsBreadcrumbs user={user} />

      <Box mt={2}>
        <Tabs value={selectedTab} onChange={handleChangeSelectedTab} indicatorColor="primary">
          <Tab value={UserEditTab.Details} label={getTitle('Details')} />
          <Tab value={UserEditTab.Notifications} label={getTitle('Notifications')} />
        </Tabs>
      </Box>

      {selectedTab === UserEditTab.Details && (
        <>
          <UserDetailsForm
            user={user}
            pathways={pathways}
            accessCodes={accessCodes}
            onAfterUpdate={onAfterUpdate}
          />

          <UserHistory
            userId={userId}
            pathways={pathways}
            needUpdate={needUpdateHistory}
            resetNeedUpdate={onResetNeedUpdateHistory}
          />
        </>
      )}

      {selectedTab === UserEditTab.Notifications && <UserNotifications userId={user.id} />}
    </>
  )
}
